export default "__VITE_ASSET__BOrZwKdR__"